module.exports = __webpack_public_path__ + "img/layout2.c98c1996.png";